import React from 'react';
import { useSelector } from 'react-redux';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import styled from 'styled-components';
import { RootState } from '../../redux/root';
import { dispatch } from '../../redux/store';
import { setDeleteError, setShowDeleteMessage } from '../../redux/slices/feesSlice';
import { ModalDefaultDraggable } from '../../molecules';

const FeeDeletePopup = () => {
  const { showDeleteMessage } = useSelector((s: RootState) => s.fees);

  const handleClose = () => {
    dispatch(setShowDeleteMessage(false));
    dispatch(setDeleteError(false));
  };

  if (!showDeleteMessage) return null;

  return (
    <ModalDefaultDraggable narrow centered title="Deletion Not Allowed" onClose={handleClose}>
      <Body>
        <IconCircle>
          <WarningRoundedIcon />
        </IconCircle>
        <Message>This fee cannot be deleted unless it is in pending status.</Message>
        <CloseButton type="button" onClick={handleClose}>
          Close
        </CloseButton>
      </Body>
    </ModalDefaultDraggable>
  );
};

export default FeeDeletePopup;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 18px;
  padding: 8px 4px 4px;
`;

const IconCircle = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--warning-50);

  svg {
    width: 36px;
    height: 36px;
    color: var(--warning-500);
  }
`;

const Message = styled.div`
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--neutral-700);
  max-width: 360px;
`;

const CloseButton = styled.button`
  margin-top: 4px;
  min-width: 140px;
  height: 40px;
  padding: 0 18px;
  border: none;
  border-radius: 8px;
  background: var(--primary-600);
  color: var(--neutral-0);
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.01em;
  text-transform: none;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background: var(--primary-700);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;
